import React from "react";

// styles
import styles from "./styles.module.scss";
import classNames from "classnames";

interface Props {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
  withPDF?: boolean;
  disabled?: boolean;
}

const ImageUpload = ({ handleChange, multiple, withPDF, disabled }: Props) => {
  const handleFileInputClick = (event: React.MouseEvent<HTMLInputElement>) => {
    (event.target as HTMLInputElement).value = "";
  };
  return (
    <input
      className={classNames(
        styles["image_upload"],
        disabled && styles["disabled_upload"]
      )}
      type="file"
      name="picture"
      title=""
      id="picture"
      multiple={multiple}
      accept={`image/x-png,image/jpeg,image/jpg,image/webp,image/png${
        withPDF ? ",application/pdf" : ""
      }`}
      onChange={handleChange}
      onClick={handleFileInputClick}
      disabled={disabled}
    />
  );
};

export default ImageUpload;
